module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 153.bc6eb895.png";